import { render } from "./RestartServerTab.vue?vue&type=template&id=365f5303&scoped=true"
import script from "./RestartServerTab.vue?vue&type=script&lang=js"
export * from "./RestartServerTab.vue?vue&type=script&lang=js"

import "./RestartServerTab.vue?vue&type=style&index=0&id=365f5303&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-365f5303"]])

export default __exports__